import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import { DevicesGlobe } from "@/features/overview/components/DevicesGlobe"
import { KpiStrip } from "@/features/overview/components/KpiStrip"

export const Route = createFileRoute("/_authed/dashboard")({
  component: DashboardPage,
})

function DashboardPage() {
  const { t } = useTranslation("overview")
  return (
    <div className="h-full flex flex-col min-h-0">
      <div className="border-b border-ok-border px-6 py-4 shrink-0">
        <h1 className="text-lg font-semibold tracking-tight">{t("title")}</h1>
        <p className="text-xs text-ok-foreground-muted">{t("subtitle")}</p>
      </div>
      <div className="flex-1 flex flex-col min-h-0 overflow-auto">
        <div className="shrink-0">
          <KpiStrip />
        </div>
        {/* Globe deterministic fixed height — parent `overflow-auto` küçük ekranda
            scroll eder; min-h yerine h sabit değer → DevicesGlobe container'ı
            kesin yükseklik ölçer, dot-on-small-viewport bug'ı elimine. */}
        <div className="shrink-0 h-[640px] xl:h-[760px] p-4 pt-0">
          <DevicesGlobe />
        </div>
      </div>
    </div>
  )
}
